module.exports = __webpack_public_path__ + "opticutBanner.webp?01604d554d30b7a6fd7567c0a9a420c9";